import React from 'react';
import { Warning, Info } from '@hpstellar/icons';
import { WarningAlt } from '@hpstellar/veneer-icons';

import withWindowResize from '../../ui/components/window-resize';
import { Helpers } from '../../core/src/helpers';
import './alert-message.less';

export default withWindowResize(({ type = 'info', message, device, variation, altIcon = false }) => {
    if (!message) {
        return null;
    }
    const size = device === 'desktop' ? 'm' : 's';
    const Icon = type === 'info' ? Info : Warning;
    const alertContent = Array.isArray(message) ? message.join('<br>') : message;
    return (
        <div className={`alert-message ${type}${variation ? ` ${variation}` : ''}`} id={`cto-${type}`}>
            {altIcon ? <WarningAlt size={24} /> : <Icon size={size} />}
            <div className="alert-content cust-html" dangerouslySetInnerHTML={Helpers.createMarkup(alertContent)} />
        </div>
    );
});
